import SavedProducts from '../../components/saved-items/saved-products.vue';
import { SAVED_ITEMS_SUB_MENU_PAGES } from '../../config.js';

export default {
    path: '/saved-items',
    component: SavedProducts,
    meta: {
        requiresAuth: true,
        pages: SAVED_ITEMS_SUB_MENU_PAGES,
    }
};